import { Button } from "@chakra-ui/button";
import { GoKebabVertical } from "react-icons/go";
import { Flex, Portal } from "@chakra-ui/react";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/menu";

export interface ButtonActionConciliacaoActionItem<T> {
  title: string | ((_v: T) => any);
  permission?: string;
  icon?: (_v: T) => any;
  onClick: (_v: T) => void;
  shouldRender?: (original: T) => boolean;
}
interface ButtonActionConciliacaoProps<T> {
  actions?: ButtonActionConciliacaoActionItem<T>[];
  original: T;
}

export default function ButtonActionConciliacao<T>({
  actions,
  original,
}: ButtonActionConciliacaoProps<T>) {
  const hasAnyRenderedAction = actions?.some(
    (action) => !action.shouldRender || action.shouldRender?.(original)
  );

  if (!hasAnyRenderedAction) {
    return null;
  }

  return (
    <Flex justifyContent="flex-end">
      <Menu>
        <MenuButton
          onClick={(ev) => {
            ev.stopPropagation();
          }}
          type="button"
        >
          <Button
            variant="outline"
            rounded="full"
            w="40px"
            h="40px"
            type="button"
          >
            <GoKebabVertical />
          </Button>
        </MenuButton>
        <Portal>
          <MenuList>
            {actions?.map((action, index) =>
              (action.shouldRender ? action.shouldRender?.(original) : true) ? (
                <MenuItem
                  key={index}
                  fontSize="14px"
                  onClick={(ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    action.onClick(original);
                  }}
                  type="button"
                >
                  <Flex alignItems="center" gridGap="8px" flex={1}>
                    {typeof action.icon === "function"
                      ? action.icon(original)
                      : null}
                    {typeof action.title === "function"
                      ? action.title(original)
                      : action.title}
                  </Flex>
                </MenuItem>
              ) : null
            )}
          </MenuList>
        </Portal>
      </Menu>
    </Flex>
  );
}
